module.exports = __webpack_public_path__ + "media/svg-new/check3-eae5c7ca.svg";